import { render, staticRenderFns } from "./case-action.vue?vue&type=template&id=44a40d60&"
import script from "./case-action.vue?vue&type=script&lang=js&"
export * from "./case-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports